import React, {useContext, useEffect, useRef, useState} from "react"
import ChatList, {IChat, IChatPayload} from "./chat-list";
import {Button, Card, Empty, Flex, Form, Input, List, Modal} from "antd";
import '../../styles/component/chat.scss'
import UserLoginContext from "../../context/userLoginContext";
import ChatFooter from "./chat-footer";
import {Client} from '@stomp/stompjs';
import {webSocketService} from '../../services/WebSocketService'
import {DownOutlined, PlusOutlined, SearchOutlined} from "@ant-design/icons";
import server from "../../server";

interface IUser {
    "id": string;
    "name": {
        "title": string,
        "firstName": string,
        "lastName": string
    },
    "email": string,
    "roles": string[],
    "employeeId": string,
    "active": boolean,
    "auditInfo": {
        "createdOn": string,
        "createdBy": string
    }
}

// type PaginationPosition = 'top' | 'bottom' | 'both';
// type PaginationAlign = 'start' | 'center' | 'end';

export default function ChatLayout() {
    const [createNewChatModalStatus, setCreateNewChatModalStatus] = useState<boolean>(false)
    const [selectedUser, setSelectedUser] = useState<IUser | null>(null);
    const [selectedChat, setSelectedChat] = useState<IChat>()
    const [allUsers, setAllUsers] = useState<IUser[]>([])
    const [allChats, setAllChats] = useState<IChat[]>([])
    const {user} = useContext(UserLoginContext)
    const [form] = Form.useForm();
    const [messages, setMessages] = useState<MessageEvent[]>([])
    const stompClientRef = useRef<Client | null>(null);
    // const subscriptionRef = useRef<any>(null)

    const createChatHandel = async () => {
        let chatPayload: IChatPayload = {
            ownerUserId: "",
            chatType: "",
            chatName: "",
            // chatStatus : "",
            participantUserIds: [],
        }
        if (selectedUser && user && user.id) {
            chatPayload = {
                ownerUserId: user?.id,
                chatType: "PRIVATE",
                chatName: selectedUser.name.firstName + " " + selectedUser.name.lastName,
                // chatStatus :"ACTIVE",
                participantUserIds: [selectedUser.id],

            }
        }

        try {
            const response = await server.chat.create(chatPayload)
            const splitId = response.toString().split("/");
            const chatId = splitId[splitId.length - 1]
            delete chatPayload.ownerUserId
            const newChat: IChat = {
                id: chatId.toString(),
                ...chatPayload,
                "auditInfo": {
                    "createdOn": JSON.stringify(new Date()),
                    "createdBy": "-",
                    "updatedOn": JSON.stringify(new Date()),
                    "updatedBy": "-"
                }
            }
            setAllChats([newChat, ...allChats])
            setSelectedChat(newChat);
            setCreateNewChatModalStatus(false);
            setSelectedUser(null);

            // setSelectedUser({}) todo think about this
            // response add in list


        } catch (e) {
            console.log(e);
        }
    }
    const getAllUsers = async () => {
        try {
            const users = await server.user.getUsers("")
            const anotherUsers = users.filter((user: any) => user.id !== user?.id)
            setAllUsers(anotherUsers)
            return anotherUsers[0];
        } catch (e) {
            console.log(e)
        }
    }
    const getAllChats = () => {
        try {
            //todo get all chats
            setTimeout(async () => {
                if (user && user.id) {
                    const chats = await server.chat.getAllChatByUserId(user.id)
                    setAllChats(chats)
                    // set first chat in setSelectedChat()
                    setSelectedChat(chats[0])
                }
            }, 500)
        } catch (e) {
            console.log(e);
        }
    }
    const fetchChat = () => {
        //set chat
    }
    const deleteChat = async (chatId: string) => {
        await server.chat.delete(chatId);
        const tempChats = allChats.filter((chat: IChat) => chat.id !== chatId)
        setAllChats(tempChats);
    }
    const handleSendMessage = (e: any) => {
        console.log(e)
        // e.preventDefault();
        //code here to send via webSocket
        const inputMessage = form.getFieldValue("message").trim();
        if (selectedUser && user && selectedUser.id && user.id) {
            const messagePayload = {
                "message": inputMessage,
                "encryptedSymmetricKey": "ENCRYPTED_AES_KEY",
                "encryptionType": "AES256",
                "messageType": "TEXT",
                "senderId": selectedUser.id,
                "receiverId": user.id,
                "chatThreadId": selectedChat?.id,
                "documentId": null,
                "isEncrypted": true
            }
            if (!inputMessage.trim()) return;
            if (inputMessage.trim() && stompClientRef.current?.connected) {
                stompClientRef.current.publish({
                    destination: '/app/chat', // <- important: this is backend @MessageMapping("/chat")
                    body: JSON.stringify(messagePayload),
                });
                // setInputMessage('');
                setMessages([...messages])
                //todo last empty input box
                form.resetFields();
            }
        }
    }

    const getAllMessageSelectedChat = async () => {
        try {
            if (selectedChat && selectedChat.id) {
                const tempAllMessage = await server.chat.getAllMessageByChatId(selectedChat.id)
                setMessages([...tempAllMessage])
            }
        } catch (e) {
            console.log(e)
        }
    }

    //todo pass on props on list component
    const onClickAnotherChat = (clickedChat: IChat) => {
        setSelectedChat(clickedChat);
        // change chat person then reset message
        form.resetFields();
        // setMessage("")
    }

    useEffect(() => {
        const token = JSON.parse(localStorage.getItem('token') || '{}')?.token;
        if (!token) return;
        webSocketService.connect(token);
        console.log("connected")
        return () => {
            webSocketService.disconnect();
        };
    }, []);
    // useEffect(() => {
    //     getAllUsers().then((firstUser)=>{
    //         const client = restApi.webSocketConnection(Client, setMessages, firstUser.id)
    //         client.activate();
    //         console.log(client)
    //         stompClientRef.current = client;
    //     })
    //     // establish connection
    //     // if (selectedChat && selectedChat.id) {
    //         // const client = restApi.webSocketConnection(Client, "ws-chat/websocket", setMessages, selectedChat.id)
    //
    //         // Clean up socket on component unmount
    //     // }
    //     getAllMessageSelectedChat()
    //     // const client = new Client({
    //     //     // brokerURL: 'ws://65.1.36.110/hrms/v1/ws-chat/websocket',
    //     //     brokerURL: 'ws://localhost:8080/hrms/v1/ws-chat/websocket',
    //     //     reconnectDelay: 5000, // Try reconnecting after 5 seconds if connection lost
    //     //     onConnect: () => {
    //     //         console.log('Connected!');
    //     //
    //     //         // Subscribe to a topic (ask backend which topic is correct)
    //     //         client.subscribe('/topic/messages', (message) => {
    //     //             if (message.body) {
    //     //                 setMessages((prev:any) => [...prev, message.body]);
    //     //             }
    //     //         });
    //     //     },
    //     //     onStompError: (frame) => {
    //     //         console.error('Broker reported error: ' + frame.headers['message']);
    //     //         console.error('Additional details: ' + frame.body);
    //     //     },
    //     // });
    //
    //     return () => {
    //         if (stompClientRef.current) {
    //             stompClientRef.current.deactivate();
    //         }
    //     };
    //     // const socket = io("wss://65.1.36.110/hrms-uat/v1/ws-chat/websocket", {
    //     //     reconnectionDelayMax: 10000,
    //     //     auth: {
    //     //         token: "123"
    //     //     },
    //     //     query: {
    //     //         "my-key": "my-value"
    //     //     }
    //     // });
    //     // socket.
    //     // socket.active
    //
    //
    // }, [])

    // //todo Ashish Sir code
    // const wsRef :any= useRef(null);
    //
    // useEffect(() => {
    //     const wsProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
    //     const wsUrl = `${wsProtocol}://${'65.1.36.110'}/hrms-uat/v1/ws-chat/websocket`;
    //
    //     wsRef.current = new WebSocket(wsUrl);
    //
    //     wsRef.current.onopen = () => {
    //         console.log('WebSocket connected');
    //         wsRef.current.send('Hello server!');
    //     };
    //
    //     wsRef.current.onmessage = (event:any) => {
    //         console.log('Received:', event.data);
    //     };
    //
    //     wsRef.current.onclose = () => {
    //         console.log('WebSocket closed');
    //     };
    //
    //     return () => wsRef.current.close();
    // }, []);
    useEffect(() => {
        getAllChats()
    }, [user?.id])

    useEffect(() => {
            getAllUsers()
        }, [setCreateNewChatModalStatus]
    )
    useEffect(() => {
        fetchChat();
    }, [selectedChat])
    return (<>
        <Modal className={"hrms-app chatModal"}
               open={createNewChatModalStatus}
               onCancel={() => {
                   setCreateNewChatModalStatus(false);
                   setSelectedUser(null);
               }}
               onOk={createChatHandel}

        >
            <h3> Show list of all users then select one and create a private or public chat </h3>
            {/*click then save all data of user in state */}
            {/*{allUsers.map((user:IUser)=><Card onClick={()=>setSelectedUser(user)}>*/}
            {/*    {user.name.firstName}*/}
            {/*</Card>)}*/}
            {/*<List*/}
            {/*    pagination={{ position, align }}*/}
            {/*    dataSource={allUsers}*/}
            {/*    renderItem={(item, index) => (*/}
            {/*        <List.Item>*/}
            {/*            /!*<List.Item.Meta*!/*/}
            {/*            /!*    title={{item.title}}*!/*/}
            {/*            /!*    description="Ant Design, a design language for background applications, is refined by Ant UED Team"*!/*/}
            {/*            /!*//*/}
            {/*            {item.name.firstName+ " " + item.name.lastName}*/}
            {/*        </List.Item>*/}
            {/*    )}*/}
            {/*/>*/}

            <List
                pagination={{position: 'bottom', align: 'center'}}
                dataSource={allUsers}
                className="userList"
                renderItem={(item: any, index: number) => (
                    <List.Item
                        style={{
                            backgroundColor: selectedUser?.id === item.id ? "#1077DA" : "",
                            marginTop: '8px',
                            borderRadius: '5px'
                        }}
                        onClick={() => setSelectedUser(item)}>
                        <List.Item.Meta
                            style={{alignItems: 'center'}}
                            avatar={
                                <img
                                    src={"images/userAvatar.png"}
                                    alt="avatar"
                                    className="userAvatar"
                                />
                            }
                            title={<span className={"userChatList"}
                                         style={{color: selectedUser?.id === item.id ? "#FFFFFF" : ""}}>{item.name.firstName + " " + item.name.lastName}</span>}
                            // description="Ant Design, a design language for background applications, is refined by Ant UED Team"
                        />
                    </List.Item>
                )}
            />
        </Modal>

        <Flex className={"chat-layout"}>

            <div style={{width: 500, margin: 10}} className={"chat-list"}>

                <h2 className={'chatHeading'}>Chats</h2>

                <Flex className={"left-layout"} align={"center"} justify={"space-between"}>
                    <h4 className={"header"}>
                        Recent chats <DownOutlined style={{fontSize: '12px'}}/>
                    </h4>
                    <Button className={"createNewChat"} onClick={() => {
                        setCreateNewChatModalStatus(true)
                    }}>
                        <PlusOutlined style={{paddingRight: '2px', paddingLeft: '2px'}}/> Create New Chat
                    </Button>
                </Flex>


                <Flex className={"chatSearchBar"}>
                    <Input name={"search"} placeholder={"search"}
                           prefix={<SearchOutlined style={{paddingRight: '2px'}}/>}
                           style={{flex: 2, marginRight: '10px'}}/>
                    {/*<Input type={"search"} placeholder={"Messages"}*/}
                    {/*       // suffix={<DownOutlined style={{paddingRight: '2px'}}/>} style={{flex: 1}}*/}

                </Flex>


                <section className={"participant-list"}>
                    <ChatList
                        allChats={allChats}
                        onClickAnotherChat={onClickAnotherChat}
                        getAllMessageSelectedChat={getAllMessageSelectedChat}
                        messages={messages} selectedChat={selectedChat}
                        deleteChat={deleteChat}/>
                </section>
            </div>

            <section className={"message-container"}>
                <Card style={{width: 800}} className={"messages"}>
                    <Card style={{width: 770, height: 500}}
                          title={selectedChat?.chatName || "Select a chat"}
                    >{messages.length > 0 ? messages.map((messageObj: any) => <>
                        <h5>
                            {messageObj.senderId}
                        </h5>
                        <p>{messageObj.message}</p>
                        <p>{messageObj.auditInfo.createdOn}</p>
                    </>) : <Empty description={"No Messages!"}/>}
                    </Card>
                    <ChatFooter form={form} handleSendMessage={handleSendMessage}/>
                    {/*<div>{selectedChat?.threadName}</div>*/}
                    {/*<div>{selectedChat?.threadType}</div>*/}
                </Card>
            </section>
        </Flex>
        {/* 1 button for create new chat*/}
        {/* 2 search */}
        {/* 3 chat list clickable and go to particular employee chat*/}
        {/*  4 chat */}

    </>)
}
// export default ChatLayout;
